import Marquee from "react-fast-marquee";

const ITEMS = [
  "Hook Strength",
  "Message Clarity",
  "Creative Impact",
  "Value Proposition",
  "Supporting Proof",
  "Visual Hierarchy",
  "CTA Effectiveness",
  "Brand Consistency",
];

export default function EditorialMarquee() {
  return (
    <div className="border-y border-black/10 py-8 overflow-hidden bg-white" data-testid="editorial-marquee">
      <Marquee speed={26} gradient={false} pauseOnHover>
        {ITEMS.map((item, i) => (
          <span key={i} className="flex items-center">
            <span
              className={`font-display font-black uppercase tracking-tight text-5xl md:text-7xl mx-10 ${
                i % 2 === 0 ? "text-outline-dark" : "text-[#003E75]"
              }`}
            >
              {item}
            </span>
            <span className="h-3 w-3 bg-[#FCC08A] rotate-45" />
          </span>
        ))}
      </Marquee>
    </div>
  );
}
